/**
 * @function unique
 * @description           留言去重，去重规则为：置顶-自己，留置顶；自己-精选，留自己
 *
 * @param {Array} top     置顶留言列表
 * @param {Array} self    自己留言列表
 * @param {Array} normal  精选留言列表
 */
export function unique (top, self, normal) {
  const ts_temp = exctracByKey(top, self, 'id')
  const sn_temp = exctracByKey(self, normal, 'id')

  self = getRidOf(self, ts_temp, 'id')
  normal = getRidOf(normal, sn_temp, 'id')

  return [].concat(top, self, normal)
}

/**
 * @function exctracByKey
 * @description       找到两个数组中有相同 key 值的元素，并将这些 key 以数组形式返回
 *
 * @param {Array} a   数组 a
 * @param {Array} b   数组 b
 * @param {String} key 需要检查的 key
 */
export function exctracByKey (a, b, key) {
  const result = []
  a.forEach(itemA => b.forEach(itemB => {
    if (itemB[key] === itemA[key]) result.push(itemB[key])
  }))

  return result
}

/**
 * @function getRidOf
 * @description                剔除数组中所有不合格的元素
 *
 * @param {Array} a            需要处理的数组
 * @param {Array} unquolified  不合格的值
 * @param {String} key         需要检查的 key
 */
export function getRidOf (a = [], unquolified = [], key) {
  if (unquolified.length) { return a.filter(item => unquolified.indexOf(item[key]) === -1) } else { return a }
}
